module.exports = __webpack_public_path__ + "static/media/problem.d73f6dde.png";